import { render, staticRenderFns } from "./ReferAFriendDialog.vue?vue&type=template&id=3ba13e92&scoped=true&"
import script from "./ReferAFriendDialog.vue?vue&type=script&lang=js&"
export * from "./ReferAFriendDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReferAFriendDialog.vue?vue&type=style&index=0&id=3ba13e92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba13e92",
  null
  
)

export default component.exports